import { PRODUCT_PERMISSION_SCOPE_CODES, type ProductPermissionScopeCode } from '@/features/permission-and-role/constants/scope-code';
import type { FileRoutesByFullPath } from '@/routeTree.gen';
export type AccessiblePath = Extract<keyof FileRoutesByFullPath, '/people' | '/public-ids/registry' | '/labor-core' | '/apps' | '/ids' | '/devices' | '/places' | '/equipment' | '/fleets' | '/time-and-attendance' | '/contract' | '/marketplace/store/devices' | '/settings/persons' | '/settings/permission-and-roles' | '/settings/contracting-corporation-profile'>;
export const getAccessiblePath = (hasPermissionScopes: ProductPermissionScopeCode[]): AccessiblePath | null => {
  if (hasPermissionScopes.length === 0) {
    // TODO: どの権限も持たないユーザーに対してアクションが必要
    return null;
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.APPS)) {
    return '/apps';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.PEOPLE)) {
    return '/people';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.PUBLIC_IDS)) {
    return '/public-ids/registry';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.LABOR_CORE)) {
    return '/labor-core';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.DEVICES)) {
    return '/devices';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.ID_MANAGEMENT)) {
    return '/ids';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.PLACE)) {
    return '/places';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.TIME_AND_ATTENDANCE)) {
    return '/time-and-attendance';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.CONTRACT)) {
    return '/contract';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.MARKETPLACE)) {
    return '/marketplace/store/devices';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.USER_ACCOUNTS)) {
    return '/settings/persons';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.PERMISSION_AND_ROLE)) {
    return '/settings/permission-and-roles';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.CONTRACTING_CORPORATION_PROFILE)) {
    return '/settings/contracting-corporation-profile';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.EQUIPMENT)) {
    return '/equipment';
  }
  if (hasPermissionScopes.includes(PRODUCT_PERMISSION_SCOPE_CODES.FLEET)) {
    return '/fleets';
  }
  return null;
};